import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'formik';
import ButtonQrCode from 'features/Lab/components/ButtonQrCode';
import CustomInputTextComponent from 'components/Form/CustomInputTextComponent';
import AsyncFilterSelect from 'components/Form/AsyncFilterSelect';

const InsuranceInput = ({
	promiseOptions,
	insuranceLoading = false,
	mainFieldName,
	mainFieldDefaultValue,
	numberFieldName,
	qrCodeButtonOnClick,
	rowStyle,
	disabled = false,
}) => {
	return (
		<Grid className='gridWithNoMarginMobile' style={{ display: 'flex', flex: 1 }}>
			<Grid.Row style={rowStyle}>
				<Grid.Column mobile={16} tablet={8} computer={8}>
					<Field
						component={AsyncFilterSelect}
						name={mainFieldName}
						customlabel={`Mutuelle`}
						promiseOptions={promiseOptions}
						placeholder='Sélectionner une mutuelle'
						defaultValue={mainFieldDefaultValue}
						disabled={disabled}
						isLoading={insuranceLoading}
					/>
				</Grid.Column>
				<Grid.Column mobile={14} tablet={6} computer={6}>
					<Field
						type='text'
						name={numberFieldName}
						customlabel={`N° Mutuelle`}
						placeholder=''
						component={CustomInputTextComponent}
						disabled={disabled}
					/>
				</Grid.Column>
				<Grid.Column
					mobile={2}
					tablet={2}
					computer={2}
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'flex-end',
					}}
				>
					<ButtonQrCode
						type='button'
						disabled={disabled}
						onClick={qrCodeButtonOnClick}
						popupContent='Scanner un numéro de mutuelle'
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default InsuranceInput;
